import { contentsSlider } from "./namespace/contentsSlider";
import { fadeInElementsOnViewport } from "./namespace/fadeInElementsOnViewport";
import { initializeTabSwitching } from "./namespace/initializeTabSwitching";
import { initModal } from "./namespace/initModal";
import { toggleTextVisibility } from "./namespace/toggleTextVisibility";
import { pickUpAccordion } from "./namespace/pickUpAccordion";
import { scrollTop } from "./namespace/scrollTop";
import { fadeInComments } from "./namespace/fadeInComments";
import { handleScroll } from "./namespace/handleScroll";

function anniversary25th() {
  const contentsCarousel = document.querySelector("#contentsCarousel");
  if (contentsCarousel) {
    contentsSlider();
  }
  fadeInElementsOnViewport();
  initializeTabSwitching();
  initModal();
  toggleTextVisibility();
  pickUpAccordion();
  scrollTop();
  fadeInComments();
  handleScroll();
}

export { anniversary25th };
